import React, {useState, useEffect} from 'react';
import { Input } from '@chakra-ui/react';
import { Link, useLocation } from 'react-router-dom';

import paypal from '../../assets/paypal.svg';
import youtube from '../../assets/youtube.svg';
import card from '../../assets/card.svg';
import americanExpress from '../../assets/americanExpress.svg';
import applepay from '../../assets/applepay.svg';
import googlepay from '../../assets/googlepay.svg';
import instagram from '../../assets/instagram.svg';
import amazonpay from '../../assets/amazonpay.svg';
import visa from '../../assets/visa.svg';
import twitter from '../../assets/twitter.svg';
import pinterest from '../../assets/pinterest.svg';
import { BiCopyright } from 'react-icons/bi';
import customerService1 from '../../assets/customerService1.png';
import customerService2 from '../../assets/customerService2.png';
import customerService3 from '../../assets/customerService3.png';
import WhatsappPopup from '../Popups/whatsappPopup';
import { useUserContext } from '../../context/user_context';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import facebookImage from "../../assets/facebookImage.png"
import handleexceptionlogo from "../../assets/handleexceptionlogo.png"
// import { CiFacebook } from 'react-icons/ci';


const Footer = () => {
  const [isOpenWhatsapp, setIsOpenWhatsapp]=useState(false)
  const {currentUser}=useUserContext()
  const history=useHistory()
   const { pathname } = useLocation();

   useEffect(() => {
     window.scrollTo(0, 0);
   }, [pathname]);
  const data = [
    {
      header: 'Company',
      data: {
        'About Us': '/about',
        'Our Stores': '/stores',
      },
    },
    {
      header: 'Quick Links',
      data: {
        Category: '/collections',
        Collection: '/collections',
        Offers: '/home',
      },
    },
    {
      header: 'Legal',
      data: {
        'Terms & Conditions': '/termsAndConditions',
        'Privacy Policy': '/privacyPolicy',
      },
    },
    {
      header: 'Order',
      data: {
        'Shipping Policy': '/complimentaryShipping',
      },
    },
    {
      header: 'Contact',
      data: {
        '11-9-7/A, NH, Prabhat Nagar, Laxmi Nagar Colony, Kothapet, Hyderabad, Telangana 500102':
          '',
        "8367243143": '',
        'Support@mukundajewellers.com': '',
      },
    },
  ];
    const customerServiceData = [
      {
        img: customerService2,
        title: 'Book an Appointment',
        description:
          'We’re happy to help with in-store or virtual appointments.',
        btnText: 'Book Now',
      },
      {
        img: customerService1,
        title: 'Complementary Shipping & Exchange',
        description:
          'We offer complementary shipping and exchanges on all orders.',
        btnText: 'Learn More',
      },
      {
        img: customerService3,
        title: 'At Your Service',
        description: 'Our customer care experts are always here to help you.',
        btnText: 'Contact- 8367243143',
      },
    ];

    const handleBookAppointment=()=>{
      setIsOpenWhatsapp(true)
    }

    const handleComplementaryShipping=()=>{
      history.push("/complimentaryShipping")
    }

  return (
    <div className='bg-[#010535] pb-4'>
      <div className='bg-[#010535] text-white flex flex-wrap justify-center gap-6 p-6 md:py-10 rounded-2xl'>
        {customerServiceData.map((e, i) => (
          <div
            key={i}
            className='flex flex-col justify-center items-center gap-3 text-center p-3'
            onClick={
              e.title === 'Book an Appointment'
                ? handleBookAppointment
                : e.title === 'Complementary Shipping & Exchange'
                ? handleComplementaryShipping
                : ''
            }
          >
            <img src={e.img} alt={e.title} className='w-10 h-10' />
            <h1 className='font-[400] text-lg'>{e.title}</h1>
            <p className='text-sm text-white'>{e.description}</p>
            <p className='text-[#F4B41A] text-sm cursor-pointer hover:underline'>
              {e.btnText} { e.title!=="At Your Service" ? '>':""}
            </p>
          </div>
        ))}
      </div>
      <footer className='bg-white text-black px-6 py-10 w-full mb-4'>
        <div className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-8 mb-10'>
          {data?.map((e, i) => (
            <div key={i} className='flex flex-col gap-3'>
              <h1 className='font-semibold text-lg md:text-xl'>{e.header}</h1>
              {Object.keys(e.data).map((text, j) => (
                <Link to={e.data[text]}>
                  <p key={j} className='text-sm text-gray-700 hover:text-black'>
                    {text}
                  </p>
                </Link>
              ))}
            </div>
          ))}
        </div>

        <div className='w-full flex flex-col lg:flex-row justify-between gap-10 pt-8'>
          <div className='w-full lg:w-[50%] flex flex-col justify-center md:items-start items-end'>
            <h1 className='underline text-sm sm:text-base mb-3'>
              We accept the following payment options
            </h1>
            <div className='flex flex-wrap gap-4 items-center'>
              <img src={visa} alt='payment' className='w-10 h-auto' />
              <img src={card} alt='payment' className='w-10 h-auto' />
              <img
                src={americanExpress}
                alt='payment'
                className='w-10 h-auto'
              />
              <img src={applepay} alt='payment' className='w-10 h-auto' />
              <img src={googlepay} alt='payment' className='w-10 h-auto' />
              <img src={amazonpay} alt='payment' className='w-10 h-auto' />
            </div>
          </div>
        </div>

        <div className='w-full flex flex-col sm:flex-row md:items-end justify-between items-center mt-10 pt-6 text-sm'>
          <p className='flex gap-2 justify-center items-center'>
            <BiCopyright /> Mukunda Jewelers 2025
          </p>
          
          <div className='flex gap-5 mt-3 sm:mt-0 justify-center items-center'>
            <a
              target='_blank'
              href='https://www.instagram.com/mukundajewellershyd?igsh=dGk2a3lmeGN3aHMz'
            >
              <img
                src={instagram}
                alt='social'
                className='w-5 h-5 cursor-pointer'
              />
            </a>

              <a
              target='_blank'
              href='https://youtube.com/@mukundajewellerskothapet?si=lfSTyUbcL2dSt9jQ'
            >
              <img
                src={youtube}
                alt='social'
                className='w-5 h-5 cursor-pointer'
              />
            </a>
            <a
              target='_blank'
              href='https://www.facebook.com/share/19yoizR4W5/?mibextid=wwXIfr'
            >
              <img
                src={facebookImage}
                alt='facebook'
                className='w-10 h-10 cursor-pointer'
              />
            </a>
          </div>
        </div>
      </footer>
      {isOpenWhatsapp && (
        <WhatsappPopup
          setIsOpenWhatsapp={setIsOpenWhatsapp}
          productId={null}
          username={currentUser ? currentUser.username : ''}
        />
      )}
      <a target='_blank' href='https://heits.in/'>
        <p className='flex items-center justify-end text-white mr-4'>Powered by <img src={handleexceptionlogo}/></p>
      </a>
    </div>
  );
};

export default Footer;
